import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { environment } from '@env/environment';
import { AuthService } from '@services/auth/auth.service';
import { APP_CONFIG, IAppConfig } from 'src/app/app.config/app.config';
import { StorageService } from './storage.service';
import { ConfiguracionApp } from '@interfaces/interface-bakend/app-web-config/app-web-config.interfaces';
import { Response } from '@interfaces/interface-bakend/response';
const URLBACKEND = environment.urlBackend;

@Injectable({
    providedIn: 'root',
})
export class ConfigAppService {
    version!: string;
    urlIos!: string;
    urlAndroid!: string;
    googleLogin!: boolean;
    configApp!: ConfiguracionApp;

    constructor(
        private authService: AuthService,
        private http: HttpClient,
        @Inject(APP_CONFIG) private iAppConfig: IAppConfig,
        private storageService: StorageService,
    ) {}

    async cargarConfiguracion(): Promise<boolean> {
        try {
            const resp: any = await this.getConfiguracion();

            if (!resp || resp.length === 0) {
                return false;
            }

            this.configApp = resp[0];
            this.version = this.configApp.version;
            this.urlIos = this.configApp.urlIos;
            this.urlAndroid = this.configApp.urlAndroid;
            this.googleLogin = this.configApp.googleLogin;

            return true;
        } catch (error) {
            console.error('Error al cargar la configuración:', error);
            return false; // Retorna false en caso de error
        }
    }

    getConfiguracion() {
        return new Promise((resolve) => {
            /* LLAVES DE SEGURIDAD */
            const headers = new HttpHeaders({
                clientid: this.iAppConfig.clientid,
                clientsecret: this.iAppConfig.clientsecret,
            });
            this.http
                .get<Response>(`${URLBACKEND}/app-config/findAll`, { headers })
                .subscribe((resp) => {
                    resolve(resp.response);
                });
        });
    }

    geturlIos() {
        return this.urlIos;
    }

    geturlAndroid() {
        return this.urlAndroid;
    }

    getVersion(): Promise<string> {
        return new Promise((resolve) => {
            /* LLAVES DE SEGURIDAD */
            const headers = new HttpHeaders({
                clientid: this.iAppConfig.clientid,
                clientsecret: this.iAppConfig.clientsecret,
            });
            this.http
                .get<Response>(`${URLBACKEND}/app-config/findAll`, { headers })
                .subscribe((config: any) => {
                    if (config.response.length > 0) {
                        this.version = config.response[0].version;
                        resolve(this.version);
                    }
                });
        });
    }

    getAppLocalVersion() {
        return environment.version;
    }

    async getGoogleLogin(): Promise<boolean> {
        await this.cargarConfiguracion();
        return this.googleLogin;
    }

    async getServerTime(): Promise<string> {
        try {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });
            const response: any = await this.http
                .get(`${URLBACKEND}/app-config/getServerTime`, { headers })
                .toPromise();
            return response.response as string; // Suponiendo que `response.response` contiene el valor de fecha como string
        } catch (error) {
            console.error('Error al obtener la fecha del servidor:', error);
            throw new Error('Error al obtener la fecha del servidor'); // Manejar el error o lanzarlo nuevamente según tus necesidades
        }
    }
}
